// Calendar days as YYYY-MM-DD strings, the player's local date (see
// todayISO in meta/save.ts). Day arithmetic runs on UTC midnights, so time
// zones and daylight-saving changes never shift a day.

export const DAY_MS = 86_400_000;

/** Days since 1970-01-01. */
export function dayNumber(iso: string): number {
  const [y = 1970, m = 1, d = 1] = iso.split('-').map(Number);
  return Math.round(Date.UTC(y, m - 1, d) / DAY_MS);
}

export function isoFromDay(n: number): string {
  return new Date(n * DAY_MS).toISOString().slice(0, 10);
}

export function addDays(iso: string, k: number): string {
  return isoFromDay(dayNumber(iso) + k);
}

/** 0 = Monday … 6 = Sunday (1970-01-01 was a Thursday). */
export function weekday(iso: string): number {
  return (((dayNumber(iso) + 3) % 7) + 7) % 7;
}

/** Milliseconds until the player's next local midnight (DST-aware). */
export function msToMidnight(now: Date = new Date()): number {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() - now.getTime();
}
